// extracted by mini-css-extract-plugin
module.exports = {"videos-per-category__heading":"videos-per-category_videos-per-category__heading__vYJRC"};